import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about-us',
  standalone: false,
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent {
  @Input() eyebrowIcon: string = '';
  @Input() eyebrowIconColor: string = '#96080B';
  @Input() eyebrowText: string = 'About Us';
  @Input() headline: string = 'We help create spaces for generosity to flourish around the world.';
  @Input() subtext: string = 'By connecting generous hearts and vetted charities from all over the world through technology, we empower giving that transcends geography and multiplies impact.';
  @Input() buttonlabel: string = 'Learn More About GivingSpace';
  @Input() videoSrc: string = '';
  @Input() mainImageSrc: string = '';
  @Input() overlayImage: string = '';
  @Input() onButtonClick?: () => void;

  constructor(private router: Router) {}

  isVideo(src: string): boolean {
    const ext = src.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
    return ext === 'mp4' || ext === 'mov';
  }

  handleButtonClick(): void {
    if (this.onButtonClick) {
      this.onButtonClick();
    } else {
      this.router.navigate(['/about']);
    }
  }
}
